import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/secure')({
  component: SecureRouteLayout,
});

function SecureRouteLayout() {
  return <Outlet />;
}
